import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import ContentDrawer from '../ContentDrawer';
import StackItemForm from '../StackItemForm';
import translations from './translations';

const AddProductDrawer = ({ formProps, isOpen, onAdd, onClose, title }) => {
  const intl = useIntl();

  const handleAddProduct = product => {
    if (onAdd && typeof onAdd === 'function') {
      onAdd(product);
    }
  };

  return (
    <ContentDrawer
      title={title ?? intl.formatMessage(translations.title)}
      isOpen={isOpen}
      handleClose={onClose}
      drawerWidth="600px"
    >
      <StackItemForm {...formProps} onCancel={onClose} onSubmit={handleAddProduct} />
    </ContentDrawer>
  );
};

AddProductDrawer.propTypes = {
  formProps: PropTypes.object,
  isOpen: PropTypes.bool,
  onAdd: PropTypes.func,
  onClose: PropTypes.func,
  title: PropTypes.string,
};

AddProductDrawer.defaultProps = {
  formProps: {},
  isOpen: false,
  onAdd: undefined,
  onClose: undefined,
  title: undefined,
};

export default AddProductDrawer;
